import React from "react";
// Change: Import FaCarBurst instead of FaCarCrash for fa6 compatibility
import { FaGavel, FaUsers, FaCarBurst, FaRing, FaScaleBalanced } from "react-icons/fa6";
import aboutImage from "../../assets/images/Founder-image/founder.jpg";

const AboutSection = () => {
  const COLORS = {
    bgPrimary: "#080C10",
    bgCard: "#0D151C",
    gold: "#C8A27C",
    goldLight: "#E5D1B3",
    textGray: "#94A3B8",
  };

  const expertise = [
    { icon: <FaScaleBalanced />, title: "Civil Law", desc: "Property, contracts, and recovery." },
    { icon: <FaGavel />, title: "Criminal Defense", desc: "Expert bail and trial strategy." },
    { icon: <FaRing />, title: "Matrimonial", desc: "Divorce and Court Marriages." },
    // Change: Use FaCarBurst here
    { icon: <FaCarBurst />, title: "Accidental", desc: "MACT and insurance claims." },
  ];

  return (
    <section className="py-20 px-6 lg:px-12 bg-[#080C10] overflow-hidden relative">
      {/* Background Justice Watermark */}
      <div className="absolute top-20 -right-20 opacity-[0.02] select-none pointer-events-none rotate-90 hidden lg:block">
        <h1 className="text-[20vw] font-serif leading-none text-white">ADVOCATE</h1>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          
          {/* Left Side: Editorial Image Layout */}
          <div className="w-full lg:w-1/2 relative">
            <div className="relative z-10 rounded-2xl overflow-hidden border border-white/10 group shadow-2xl">
              <img
                src={aboutImage}
                alt="Advocate Saurav Dagar"
                className="w-full aspect-[4/5] object-cover grayscale-[0.3] hover:grayscale-0 transition-all duration-700"
              />
              <div className="absolute bottom-6 right-6 bg-[#0D151C]/90 backdrop-blur-xl p-6 rounded-xl border border-[#C8A27C]/30 shadow-2xl">
                <p className="text-[#C8A27C] text-4xl font-serif font-bold italic"></p>
                <p className="text-white text-[10px] uppercase tracking-[0.2em] font-semibold mt-1">
                  Professional <br /> Legal Excellence
                </p>
              </div>
            </div>
            <div className="absolute -top-6 -left-6 w-full h-full border border-[#C8A27C]/20 rounded-2xl -z-0" />
          </div>

          {/* Right Side: Content */}
          <div className="w-full lg:w-1/2">
            <div className="flex items-center gap-4 mb-6">
              <div className="h-[1px] w-12 bg-[#C8A27C]" />
              <span className="text-[#C8A27C] uppercase tracking-[0.4em] text-xs font-black">
                Ghaziabad's Premier Legal Expert
              </span>
            </div>

            <h2 className="text-5xl lg:text-7xl font-serif font-bold text-white mb-8 leading-[1.1]">
              Adv. Saurav <span className="italic font-normal text-[#C8A27C]">Dagar</span>
            </h2>

            <div className="space-y-6 mb-12">
              <p className="text-xl text-gray-300 leading-relaxed font-light italic border-l-2 border-[#C8A27C] pl-8">
                Providing strategic, results-driven legal representation across Uttar Pradesh with a focus on integrity, transparency, and relentless advocacy.
              </p>
              <p className="text-gray-400 leading-relaxed text-lg pl-8">
                Based in Ghaziabad, Advocate Saurav Dagar has built a reputation for excellence in complex civil and criminal litigation, helping families and individuals navigate the intricacies of the Indian legal system.
              </p>
            </div>

            {/* Expertise Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {expertise.map((item, idx) => (
                <div 
                  key={idx} 
                  className="p-6 bg-[#0D151C] border border-white/5 rounded-xl hover:border-[#C8A27C]/40 transition-all group"
                >
                  <div className="text-2xl text-[#C8A27C] mb-4 group-hover:scale-110 transition-transform">
                    {item.icon}
                  </div>
                  <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-2">
                    {item.title}
                  </h4>
                  <p className="text-gray-500 text-xs leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-white/5 flex flex-wrap items-center gap-8">
              <div>
                <p className="text-[#C8A27C] text-3xl font-bold">1000+</p>
                <p className="text-white/40 text-[10px] uppercase tracking-widest">Cases Resolved</p>
              </div>
              <div className="h-8 w-[1px] bg-white/10 hidden sm:block" />
              <div>
                <p className="text-[#C8A27C] text-3xl font-bold">U.P.</p>
                <p className="text-white/40 text-[10px] uppercase tracking-widest">Jurisdiction Focus</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;